import { Icon } from "./components/Icon";
import { i18n } from "./i18n";
import { select, selectAll } from "@fruugo/utilities";

enum ReadMoreState {
  Open,
  Closed,
}

export enum ReadMoreListDevice {
  All,
  MobileOnly,
}

/**
 * @description Similar to read-more, but it works on list items rather than text
 */
export class ReadMoreList {
  container: HTMLElement | null;
  visibleItems = 1;
  state = ReadMoreState.Closed;
  items: Element[] = [];
  readMoreButtonClass = "js-read-more-list-button";

  clampVisibleItems: boolean;

  constructor(
    selector: string,
    device: ReadMoreListDevice = ReadMoreListDevice.All,
    clampVisibleItems = true
  ) {
    this.clampVisibleItems = clampVisibleItems;
    this.container = select(selector) ?? null;
    if (!this.container) return;

    if (
      device === ReadMoreListDevice.MobileOnly &&
      !window.matchMedia("(max-width: 768px)").matches
    )
      return;

    const itemsClass = this.container.dataset.itemClass;
    if (!itemsClass) return;

    const items = selectAll(itemsClass);
    this.items = Array.from(items);
  }

  toggleItems() {
    this.items &&
      this.items.forEach((item, i) => {
        // For the initially visible items
        if (i < this.visibleItems && this.clampVisibleItems) {
          this.state === ReadMoreState.Closed
            ? item.classList.add("line-clamp")
            : item.classList.remove("line-clamp");
        }

        // For the other items
        if (i >= this.visibleItems) item.classList.toggle("d-none");
      });
  }

  init() {
    this.toggleItems();
    this.insertButton();
  }

  insertButton() {
    if (!this.items || this.items.length < 2) return;
    this.items[this.items.length - 1].insertAdjacentElement(
      "afterend",
      this.getButton()
    );
  }

  getButton() {
    const text =
      this.state === ReadMoreState.Closed
        ? i18n("generic.show-more")
        : i18n("generic.show-less");

    const icon =
      this.state === ReadMoreState.Closed ? (
        <Icon name="chevron-down" fill="#000" />
      ) : (
        <Icon name="chevron-up" fill="#000" />
      );

    return (
      <button
        class={`ReadMore d-flex ${this.readMoreButtonClass} tw:focus-visible:ring-2 tw:focus-visible:ring-fruugo-blue-secondary tw:focus-visible:ring-offset-2`}
        onClick={() => this.handleClick()}
      >
        {text} {icon}
      </button>
    );
  }

  removeButtons() {
    this.container?.querySelector(`.${this.readMoreButtonClass}`)?.remove();
  }

  toggleButtons() {
    this.removeButtons();
    this.insertButton();
  }

  handleClick() {
    // Invert state
    this.state =
      this.state === ReadMoreState.Closed
        ? ReadMoreState.Open
        : ReadMoreState.Closed;

    this.toggleItems();
    this.toggleButtons();
  }
}
